var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSegmentedBarChart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 23,
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m.015 15.978.021 15.985L32 32v-1.574h-.729V16.412h-6.487v14.014h-.875V12.215h-6.488v18.211h-.874V3.672h-6.488v26.754h-.874v-19.26H2.697v19.26H1.531V0H0l.015 15.978Zm15.803-9.57v1.985h-5.03V4.422h5.03v1.986Zm-7.362 9.405v3.822h-5.03v-7.644h5.03v3.822Zm14.724 2.023v4.871h-5.03v-9.742h5.03v4.871Zm7.362 1.274v1.874h-5.029v-3.747h5.029v1.873Z"
})));
export default SvgIconSegmentedBarChart;